/*
 * Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* windowmanager.module.ts
* 3-12-2019 - Jelmer Jellema - Spin in het Web B.V.
*
* Aparte module voor alles met de windowmanager
*
* Importeren als
* imports: [
*   ...,
*   SihwWindowmanagerModule
* ]
*
* Gebruikt DynamicModule
* https://www.npmjs.com/package/ng-dynamic-component
*/


import {DynamicModule} from 'ng-dynamic-component';
import {WindowComponent} from './window/window.component';
import {AngularDraggableModule} from 'angular2-draggable';
import {SihwWindowmanager} from './windowmanager/windowmanager';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';

@NgModule({
  declarations: [
    WindowComponent,
    SihwWindowmanager
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    DynamicModule,
    AngularDraggableModule //https://www.npmjs.com/package/angular2-draggable
  ],
  exports: [
    WindowComponent,
    SihwWindowmanager
  ]
})
export class SihwWindowmanagerModule {
}

